import React from 'react';
import './titles.css'
const Titles = (props) => {
    return ( 
        <h1 className={props.stylee}>{props.title}</h1>
     );
}
 
export default Titles;